export enum INGREDIENT_TYPE {
    BUN = 'bun',
    SAUCE = 'sauce',
    MAIN = 'main',
}